module.exports = __webpack_public_path__ + "img/SMT_38_Ms_Ivy_Lim.a119e029.jpg";